module.exports = __webpack_public_path__ + "img/cloudy-day.8fb38a11.png";